/* eslint-disable max-len, react/prop-types */
const Icon = ({ className = '' }) => (
  <svg className={className} width="36" height="36" viewBox="0 0 36 36">
    <title>Outlook Calendar</title>
    <g fill="#0072c6">
      <path d="m22.5 7.6v7l2.5 1.5h.3l10.6-7.1c0-.8-.8-1.5-1.2-1.5h-12.2z" />
      <path d="m22.5 17.3 2.2 1.5c.3.2.7 0 .7 0-.4.2 10.4-6.9 10.4-6.9v12.9c0 1.4-.9 2-1.9 2h-11.4z" />
      <g transform="matrix(3.9178712 0 0 3.9178712 -13.481403 -41.384473)">
        <path d="m6.2 14.2c-.2 0-.4.1-.5.3s-.2.4-.2.7.1.5.2.7.3.3.5.3.3-.1.5-.3c.1-.2.2-.4.2-.7s-.1-.6-.2-.7c-.2-.3-.3-.3-.5-.3z" />
        <path d="m3.5 11.6v7l5.3 1.1v-9.2zm3.6 4.7c-.2.3-.5.4-.9.4s-.6-.1-.9-.4c-.2-.3-.3-.6-.3-1.1s.1-.9.3-1.2.5-.5.9-.5.6.1.9.4c.2.3.3.7.3 1.1 0 .6-.1 1-.3 1.3z" />
      </g>
    </g>
  </svg>
);
export default Icon;
